import { useSession } from '@/auth/useSession';
import { isCoachOnboarding } from '@/lib/coach-utils';
import { DEFAULT_PAGE_SIZE } from '@/lib/pagination';
import { StudentHome } from '@/routes/_layout/-components/student-home';
import { isAirAdmin, isCoach, isSchoolAdmin, isStudent } from '@airreading/common';
import { createFileRoute, Navigate } from '@tanstack/react-router';
import { useMemo } from 'react';

export const Route = createFileRoute('/_layout/')({
  component: Index,
});

function Index() {
  const { actingUser } = useSession();

  const userIsStudent = useMemo(() => isStudent(actingUser), [actingUser]);
  const userIsCoach = useMemo(() => isCoach(actingUser), [actingUser]);
  const userIsAirAdmin = useMemo(() => isAirAdmin(actingUser), [actingUser]);
  const userIsSchoolAdmin = useMemo(() => isSchoolAdmin(actingUser), [actingUser]);

  if (!(userIsStudent || userIsCoach || userIsAirAdmin || userIsSchoolAdmin)) {
    return <div>Unknown user</div>;
  }
  if (userIsAirAdmin) {
    return <Navigate to="/sessions" search={{ pageIndex: 0, pageSize: DEFAULT_PAGE_SIZE }} replace />;
  }
  // School portal wins over teacher portal when the user also has the coach role.
  if (userIsSchoolAdmin) {
    return <Navigate to="/school-students" search={{ pageIndex: 0, pageSize: DEFAULT_PAGE_SIZE }} replace />;
  }
  if (userIsCoach) {
    if (isCoachOnboarding(actingUser)) {
      return <Navigate to="/getting-ready-to-teach" replace />;
    }
    return <Navigate to="/my-classes/calendar" replace />;
  }
  return <StudentHome />;
}
